import type { BoardCell, Player } from '../../types';
import { CHARACTERS } from '../../data';
import { useAutoConfirm } from '../../hooks/useAutoConfirm';
import styles from './BuyDialog.module.css';

interface Props {
  cell: BoardCell;
  player: Player;
  onConfirm: (buy: boolean) => void;
}

export default function BuyDialog({ cell, player, onConfirm }: Props) {
  const char = CHARACTERS.find(c => c.id === player.characterId);
  let price = cell.price || 0;
  if (char?.id === 'fox') price = Math.round(price * 0.9);

  const canAfford = player.money >= price;
  const rent = cell.rentTable?.[0] || 0;

  const { countdown, cancelAutoConfirm } = useAutoConfirm({
    onAutoConfirm: () => onConfirm(false), // 10秒后默认不购买
    delayMs: 10000,
    enabled: true,
  });

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <div className={styles.header}>
          <span className={styles.emoji}>{cell.emoji}</span>
          <h3 className={styles.title}>{cell.name}</h3>
          {cell.street && (
            <span className={styles.street}>{cell.street}</span>
          )}
        </div>

        <div className={styles.details}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>购买价格</span>
            <span className={styles.detailValue}>
              {char?.id === 'fox' ? (
                <>
                  <span className={styles.originalPrice}>💰{cell.price}</span>
                  <span className={styles.discountedPrice}>💰{price}</span>
                  <span className={styles.discountBadge}>9折</span>
                </>
              ) : (
                <span>💰{price}</span>
              )}
            </span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>基础租金</span>
            <span className={styles.detailValue}>💰{rent}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>升级费用</span>
            <span className={styles.detailValue}>💰{cell.upgradeCost || price}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>你的余额</span>
            <span className={styles.detailValue}>💰{player.money}</span>
          </div>
        </div>

        <div className={styles.countdown}>
          ⏰ {countdown}s 后自动跳过
        </div>

        <div className={styles.actions}>
          <button
            className={styles.buyBtn}
            onClick={() => { cancelAutoConfirm(); onConfirm(true); }}
            disabled={!canAfford}
          >
            {canAfford ? '购买' : '余额不足'}
          </button>
          <button className={styles.skipBtn} onClick={() => { cancelAutoConfirm(); onConfirm(false); }}>
            不购买（进入拍卖）
          </button>
        </div>
      </div>
    </div>
  );
}
